class ExternalLoader {
  constructor() {
    let HTMLElement = typeof HTMLElement != "undefined" ? HTMLElement : Element

    HTMLElement.prototype.prepend = function(element) {
      if (this.firstChild) {
        return this.insertBefore(element, this.firstChild)
      } else {
        return this.appendChild(element)
      }
    }
  }
  createPlayer(name, props) {
    let container = document.getElementById("player"),
      player = document.createElement(name)
    this.setAttributes(player, props)

    container.appendChild(player)

    return player
  }
  createObject(name, props, container = document.body) {
    let object = document.createElement(name)
    this.setAttributes(object, props)

    container.appendChild(object)

    return object
  }
  createScript(props) {
    let container = document.body,
      script = document.createElement("script")

    !props.type && (props.type = "text/javascript")

    this.setAttributes(script, props)
    container.appendChild(script)
  }
  setAttributes(element, props) {
    for (let key in props) {
      element.setAttribute(key, props[key])
    }
  }
}

export default new ExternalLoader()
